import { Component } from '@angular/core';

@Component({
  selector: 'app-generic-aha-gold-left-panel',
  templateUrl: './generic-aha-gold-left-panel.component.html',
  styleUrls: ['./generic-aha-gold-left-panel.component.scss']
})
export class GenericAhaGoldLeftPanelComponent {
}
